var map = {
	"./assets/abz-logo.png": "8cf7",
	"./assets/beavers/beaver.png": "a4db",
	"./assets/beavers/beaver1.png": "594b",
	"./assets/beavers/beaver2.png": "2a1a",
	"./assets/beavers/beaver3.png": "a3d3",
	"./assets/beavers/beavers.png": "5987",
	"./assets/beavers/correct.png": "afa5",
	"./assets/beavers/wrong.png": "978d",
	"./assets/bridges/b1.png": "6297",
	"./assets/bridges/b3.png": "13d3",
	"./assets/bridges/b4.png": "9ccf",
	"./assets/bridges/b5.png": "e32c",
	"./assets/bridges/b6.png": "6d29",
	"./assets/bridges/b7.png": "0b21",
	"./assets/bridges/bridge.png": "eb42",
	"./assets/bridges/bridge_false.png": "8d6b",
	"./assets/bridges/bridge_long.png": "d8fe",
	"./assets/bridges/bridge_medium.png": "be87",
	"./assets/bridges/bridge_short.png": "8d19",
	"./assets/bridges/bridge_true.png": "144e",
	"./assets/bridges/kiosk_false.png": "4efb",
	"./assets/bridges/kiosk_true.png": "ccce",
	"./assets/bridges/land_tower.png": "597f",
	"./assets/bridges/land_tower_false.png": "7532",
	"./assets/bridges/land_tower_true.png": "df80",
	"./assets/bridges/tower.png": "e743",
	"./assets/bridges/tower2_true.png": "1a75",
	"./assets/bridges/tower_false.png": "74d5",
	"./assets/bridges/tower_true.png": "b1b9",
	"./assets/ethz-logo.svg": "5dd7",
	"./assets/faces/face1.png": "a7dc",
	"./assets/faces/face2.png": "bb73",
	"./assets/faces/face3.png": "7fe9",
	"./assets/faces/face4.png": "8a10",
	"./assets/faces/face5.png": "6449",
	"./assets/faces/face6.png": "47e8",
	"./assets/faces/face7.png": "2ced",
	"./assets/faces/face8.png": "403b",
	"./assets/icons/back.png": "0142",
	"./assets/icons/check.png": "e209",
	"./assets/icons/full-screen.png": "c4f7",
	"./assets/icons/help.png": "be4c",
	"./assets/icons/home.png": "297d",
	"./assets/icons/info.png": "e810",
	"./assets/icons/print.png": "a4a5",
	"./assets/icons/restart.png": "d6e5",
	"./assets/icons/skip.png": "de63",
	"./assets/instructions.png": "54f0",
	"./assets/logo_abz_weiss.png": "3e1c",
	"./assets/maps/graph1.png": "7a56",
	"./assets/maps/graph2.png": "8953",
	"./assets/maps/graph3.png": "07e4",
	"./assets/maps/map1.png": "5144",
	"./assets/maps/map10.png": "84e6",
	"./assets/maps/map12.png": "a9cb",
	"./assets/maps/map1_empty.png": "39cd",
	"./assets/maps/map2.png": "f3f4",
	"./assets/maps/map2_empty.png": "8d3b",
	"./assets/maps/map3.png": "a244",
	"./assets/maps/map4.png": "6849",
	"./assets/maps/map4_empty.png": "e111",
	"./assets/maps/map5.png": "8545",
	"./assets/maps/map6.png": "7449",
	"./assets/maps/map7.png": "6be1",
	"./assets/maps/map7_empty.png": "a222",
	"./assets/maps/map8.png": "7c56",
	"./assets/maps/map8_empty.png": "b698",
	"./assets/maps/map9.png": "bdd1",
	"./assets/transport/beaver_transport.png": "d825",
	"./assets/transport/beaver_transport2.png": "1e90",
	"./assets/transport/boat1.png": "161d",
	"./assets/transport/boat10.png": "1ede",
	"./assets/transport/boat2.png": "59d6",
	"./assets/transport/boat20.png": "b0db",
	"./assets/transport/boat3.png": "bd0a",
	"./assets/transport/boat30.png": "ebc4",
	"./assets/transport/boat_transport.png": "9cec",
	"./assets/transport/boatmax10.png": "260e",
	"./assets/transport/boatmax20.png": "bc4d",
	"./assets/transport/boatmax30.png": "3077",
	"./assets/transport/boats.png": "6b06",
	"./assets/transport/load_boat.png": "9a25",
	"./assets/transport/wood.png": "c126",
	"./assets/tutorials/add-weights.mp4": "93c1",
	"./assets/tutorials/build-kiosks.mp4": "4fea",
	"./assets/tutorials/build-towers.mp4": "ae62",
	"./assets/tutorials/check-kiosks.mp4": "5c70",
	"./assets/tutorials/check-towers.mp4": "af0f",
	"./assets/tutorials/check-weights.mp4": "597e",
	"./assets/tutorials/distribute-weights.mp4": "71ae",
	"./assets/tutorials/optimize-weights.mp4": "16bb",
	"./assets/weights/size0.png": "85e1",
	"./assets/weights/size1.png": "b384",
	"./assets/weights/size10.png": "f0ad",
	"./assets/weights/size11.png": "d925",
	"./assets/weights/size12.png": "b6b1",
	"./assets/weights/size2.png": "a30c",
	"./assets/weights/size3.png": "87af",
	"./assets/weights/size4.png": "4afd",
	"./assets/weights/size5.png": "0fcb",
	"./assets/weights/size6.png": "efac",
	"./assets/weights/size7.png": "77c5",
	"./assets/weights/size8.png": "7281",
	"./assets/weights/size9.png": "597a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";